import { render, staticRenderFns } from "./BaseTableColumn.vue?vue&type=template&id=0d575bc3&scoped=true&"
import script from "./BaseTableColumn.vue?vue&type=script&lang=js&"
export * from "./BaseTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableColumn.vue?vue&type=style&index=0&id=0d575bc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d575bc3",
  null
  
)

export default component.exports